export default "__VITE_ASSET__BbyYgm3C__"